import createIcon from '../../createIcon';

/**
 * @component @name VideoCameraBack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTAuNDhWNkMxOCA0LjkgMTcuMSA0IDE2IDRINEMyLjkgNCAyIDQuOSAyIDZWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDE2QzE3LjEgMjAgMTggMTkuMSAxOCAxOFYxMy41MkwyMiAxNy41VjYuNUwxOCAxMC40OFpNNSAxNkw3LjM4IDEyLjgzTDkgMTVMMTEuNjIgMTEuNUwxNSAxNkg1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideoCameraBack = createIcon('VideoCameraBack', [
  [
    'path',
    {
      d: 'M18 10.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V13.52L22 17.5V6.5L18 10.48ZM5 16L7.38 12.83L9 15L11.62 11.5L15 16H5Z',
      key: '8995k6',
    },
  ],
]);

export default VideoCameraBack;
